var _g, _path, _ellipse, _ellipse2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJockericon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_9_11",
    "data-name": "Component 9 \\u2013 11",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 46.24,
    viewBox: "0 0 56 46.24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_136",
    "data-name": "Group 136",
    transform: "translate(7.986 41.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_135",
    "data-name": "Group 135",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M609.483,1808.4H571.3c-.95,0-1.784-1.012-1.841-2.351-.062-1.454.755-2.66,1.771-2.66h38.184c.95,0,1.784,1.012,1.841,2.351C611.317,1807.19,610.5,1808.4,609.483,1808.4Z",
    transform: "translate(-569.455 -1803.385)",
    fill: "#fb6464"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M570.087,1613.207a21.331,21.331,0,0,1,10.233,5.76,17,17,0,0,1,3.732,5.656l2.55,8.554a.009.009,0,0,0,.018,0l4-8.068a15.61,15.61,0,0,1,7.708-7.553.009.009,0,0,1,.012.014,8.526,8.526,0,0,0-1.178,2.4c-1.234,4.022.911,7.522,2.635,10.333.2.318.379.619.555.914,1.043,1.751,1.718,5.113,2.074,8.078a.009.009,0,0,1-.009.01H570.578a.01.01,0,0,1-.01-.009c-.252-3.161.657-6.017,1.543-8.8a30.45,30.45,0,0,0,1.4-5.542c.335-2.768-.531-6.136-2.648-10.3-.258-.508-.52-.995-.774-1.452m-4.539-4.322-.591,2.735s0,0,0,.006c.1.142,5.613,8.063,5.027,12.909-.591,4.889-4.533,10.658-2.368,18.284a.01.01,0,0,0,.009.007h38.631a.009.009,0,0,0,.009-.009c-.011-.319-.342-9.166-2.859-13.392-2.563-4.3-6.506-9.193,2.857-13.5l0,0,2.061-2.629a.009.009,0,0,0,0-.014l-1.959-.777h0c-.011,0-.3-.024-.812-.024-2.921,0-13,.775-18.107,11.057a.009.009,0,0,1-.017,0c-.193-.583-4.547-13.122-21.88-14.651Z",
    transform: "translate(-557.857 -1605.706)",
    fill: "#fb6464"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_36",
    "data-name": "Ellipse 36",
    cx: 3.993,
    cy: 3.961,
    rx: 3.993,
    ry: 3.961,
    fill: "#fb6464"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 3.993,
    cy: 3.961,
    rx: 3.993,
    ry: 3.961,
    transform: "translate(48.014 3.961)",
    fill: "#fb6464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M664.964,1654.011c.067.266,1.759,7.282,1.182,12.747a.009.009,0,0,0,.009.01l17.332.83a.009.009,0,0,0,.01-.01l-.246-4.194s0,0,0,0c-.02-.052-2.366-6.016-2.366-6.211s-3.944-5.38-2.317-8.265a48.014,48.014,0,0,1,4.224-6,.009.009,0,0,0-.01-.014l-4.823.789-.005,0-9.687,9.277,0,0L664.97,1654A.009.009,0,0,0,664.964,1654.011Z",
    transform: "translate(-638.145 -1633.071)",
    fill: "#fb6464"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJockericon);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/jocker.icon.00aeade609bb0bfe86cc2b262334fb20.svg";
export { ForwardRef as ReactComponent };